import { CSSProperties } from "react";

const CopyIcon = ({ scale, color, style, onClick }: { scale?: number; color?: string; style?: CSSProperties, onClick?: () => void }) => {
  let c = "#1062D0";
  if (color) c = color;

  return (
    <svg
      width="21"
      height="21"
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ transform: `scale(${scale || 1})`, ...style }}
      onClick={() => onClick ? onClick() : null}
    >
      <g clipPath="url(#clip0_513_6248)">
        <path
          d="M6.66577 3.16683V14.1668C6.66577 14.653 6.85892 15.1193 7.20275 15.4632C7.54656 15.807 8.01288 16.0002 8.4991 16.0002H15.8324C16.3186 16.0002 16.7849 15.807 17.1288 15.4632C17.4726 15.1193 17.6658 14.653 17.6658 14.1668V6.13866C17.6658 5.89443 17.6169 5.65266 17.5221 5.42755C17.4273 5.20245 17.2886 4.99855 17.1139 4.82783L14.0752 1.856C13.7327 1.5211 13.2727 1.33356 12.7937 1.3335H8.4991C8.01288 1.3335 7.54656 1.52665 7.20275 1.87047C6.85892 2.21428 6.66577 2.6806 6.66577 3.16683Z"
          stroke={c}
          strokeWidth="1.2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M13.9993 16.0003V17.8337C13.9993 18.3199 13.8061 18.7862 13.4623 19.13C13.1184 19.4739 12.6521 19.667 12.1659 19.667H4.8326C4.34637 19.667 3.88006 19.4739 3.53624 19.13C3.19242 18.7862 2.99927 18.3199 2.99927 17.8337V7.75033C2.99927 7.2641 3.19242 6.79778 3.53624 6.45397C3.88006 6.11014 4.34637 5.91699 4.8326 5.91699H6.66593"
          stroke={c}
          strokeWidth="1.2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_513_6248">
          <rect width="20" height="20" fill="white" transform="translate(0.5 0.5)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default CopyIcon;
